import React, { useEffect, useState } from 'react';
import { useAppSelector } from 'src/store/hooks';
import Lottie from 'lottie-react';
import './GlobalLoader.scss';

const GlobalLoader: React.FC = () => {
    const isLoading = useAppSelector((state) => state.app.loadingCount > 0);
    const [animationData, setAnimationData] = useState<any>(null);

    useEffect(() => {
        // Load the Lottie animation from public folder
        fetch('/lottie/loading.json')
            .then((response) => response.json())
            .then((data) => setAnimationData(data))
            .catch((error) => {
                console.error('Failed to load Lottie animation:', error);
            });
    }, []);

    if (!isLoading) {
        return null;
    }

    return (
        <div className="global-loader">
            <div className="global-loader__backdrop" aria-hidden />
            {animationData ? (
                <div className="global-loader__content">
                    <Lottie
                        animationData={animationData}
                        loop={true}
                        autoplay={true}
                        style={{ width: 200, height: 200 }}
                    />
                </div>
            ) : null}
        </div>
    );
};

export default GlobalLoader;

